const API = {
    ARTICLE: '/article',
    CONVERSATIONS: '/conversations',
    ONLINE: '/conversations/online',
    CONTACT_MAIL_FORM: '/forms/sendMailForm',
    CONTACT_WHATSAPP_FORM: '/forms/sendWAForm',
    FORMS: '/forms',
    FORM: '/form',
    INIT: '/init',
    PAGE: '/page',
    SEARCH: '/search',
    TEST: '/test',
    USER: '/user'
};
export default API;
